import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { i18n } from '../i18n';

export type Language = 'de' | 'en' | 'sl' | 'tr' | 'ro';

interface LanguageState {
  language: Language;
  setLanguage: (language: Language) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: 'de',
      setLanguage: (language: Language) => {
        i18n.changeLanguage(language);
        set({ language });
      },
    }),
    {
      name: 'language-storage',
    }
  )
);
